export default {
    CREATE_SPACES: "companies/:company_id/space-management/spaces",
    WEBSITE_GROUP: "companies/:company_id/space-management/get-unit-categories",
    ACTIVATE_DEACTIVATE_SPACES: "companies/:company_id/space-management/deactivate-spaces"
};
